import { Input } from '@/lib';
import { ChangeEvent, FC, useMemo } from 'react';
import { twMerge } from 'tailwind-merge';

type DataSourceDetailNameProps = {
  isEditingName: boolean;
  dataSourceName: string;
  onDataSourceNameChange?: (event: ChangeEvent<HTMLInputElement>) => void;
};

const dataSourceClassNames = 'max-w-[100%] text-lg font-semibold text-brand-600 leading-6 py-2';

export const DataSourceDetailName: FC<DataSourceDetailNameProps> = ({ isEditingName, dataSourceName, onDataSourceNameChange }) => {
  const inputSize = useMemo(() => (dataSourceName.length > 60 ? 42 : dataSourceName.length - 2), [dataSourceName]);

  if (isEditingName) {
    return (
      <Input
        className={twMerge('w-fit pl-0.5 pr-4', dataSourceClassNames, isEditingName && 'border-brand-600 border-2')}
        wrapperClassName='max-w-[100%] w-fit'
        defaultValue={dataSourceName}
        onChange={onDataSourceNameChange}
        size={inputSize}
      />
    );
  }

  return <h2 className={dataSourceClassNames}>{dataSourceName}</h2>;
};
